<template>
    <form>
        <div class="form-newsletter w-full">
            <div class="input-field border-2 border-gray-700">
                <div class="input-field-wrap">
                <input v-model="state.email" type="text" placeholder="Indirizzo email" name="email" required
                    class="bg-gray-700 text-xl text-white py-4 px-6 h-full w-full">
                </div>
                <div class="input-errors" v-for="error of v$.email.$errors" :key="error.$uid">
                    <div class="error-msg">Controllare che l'email sia corretta</div>
                </div>
            </div>
            <div class="bg-black text-white text-lg font-bold w-1/5 h-full mt-4">
                <button type="button" 
                :disabled="state.isLoading"
                 @click.prevent="submitForm(v$)"
                class="h-full w-full py-4 border border-gray-700 bg-[#00bfff]">Iscriviti</button>
            </div>
            <div v-if="state.message_sent" class="message-sent text-green-500">{{ state.message_sent }}</div>
            <loader :loading="state.isLoading" />
        </div>
    </form>
</template>

<script>
import { reactive } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import axios from 'axios'
export default {
    name: "newsletter",
    setup() {
        const state = reactive({
            email: "",
            isLoading: false,
            message_sent:""
        })

        const rules = {
            email: { required, email }
        }

        const resetForm = (v$) => {
            v$.$reset(); // Reimposta lo stato di validazione di Vuelidate
            state.isLoading = false
            state.email = ''
        }

        const v$ = useVuelidate(rules, state)

        const submitForm = (v$) => {
            debugger
            state.isLoading = true
            state.message_sent = ''
            v$.$validate().then((success) => {
                if (!success){
                state.loading = false
                return 
            }
                const { email } = state
                
                const token = process.env.SEND_TOKEN
                const url = `${process.env.SEND_API}/${process.env.SEND_ENDPOINT_NEWSLETTER}?api_token=${token}`
               
                gtag('set', 'user_data', {
                        "email": email
                    });
            
            const data={
                action: 'send_email',
                email: email
            }
           
            const obj={
             EMAIL: email   
            }
            
            debugger
            console.log('sono qui')
            axios
            .post(url, new URLSearchParams(obj), {
          headers: {
            "Content-Type": "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
             
          },
                })
                .then(function (response) {
                    const { status, message } = response.data
                    if (status==1) {
                        // Email inviata con successo
                        state.message_sent = 'Iscrizione avvenuta con successo - Benvenuto/a'
                        resetForm(v$)
                    } else {
                        // Errore nell'invio dell'email
                        console.error(message);
                    }

                    state.isLoading = false

                })
                .catch(function (error) {
                    // Errore nella chiamata Axios
                    console.error('Errore nella chiamata Axios:', error);
                    state.isLoading = false
                });
            })
        }

        return {
            state,
            rules,
            resetForm,
            submitForm,
            v$
        }
    }
}
</script>